import { brandFilterStore, persistBrands, persistModelTypes } from './brandFilter.store.js'

export default {
  computed: {
    selBrands: {
      get() { return brandFilterStore.selBrands },
      set(v) { persistBrands(v) },
    },
    selModelTypes: {
      get() { return brandFilterStore.selModelTypes },
      set(v) { persistModelTypes(v) },
    },
    selectedBrands: {
      get() { return this.selBrands.length > 0 ? this.selBrands : this.elevatorBrands },
      set(v) {
        const effective = v.length < this.elevatorBrands.length ? v : []
        if (effective.length === 0 && this.selBrands.length === 0) return
        this.selBrands = effective
        this.selModelTypes = []
      },
    },
    selectedModelTypes: {
      get() { return this.selModelTypes.length > 0 ? this.selModelTypes : this.elevatorModelTypes },
      set(v) {
        const effective = v.length < this.elevatorModelTypes.length ? v : []
        if (effective.length === 0 && this.selModelTypes.length === 0) return
        this.selModelTypes = effective
      },
    },
  },
  methods: {
    invertBrands() {
      const invBrands = this.elevatorBrands.filter(x => !this.selBrands.includes(x))
      const invTypes = this.elevatorModelTypes.filter(x => !this.selModelTypes.includes(x))
      this.selBrands = invBrands.length < this.elevatorBrands.length ? invBrands : []
      this.selModelTypes = invTypes.length < this.elevatorModelTypes.length ? invTypes : []
    },
    onBrandsAll() {
      persistBrands([])
      persistModelTypes([])
    },
  },
}



// WEBPACK FOOTER //
// ./src/brandFilter.mixin.js